import coordinator from './coordinator'
import manager from './manager'
import leader from './leader'
import workman from './workman'

export default {
  coordinator,
  manager,
  leader,
  workman
}



// WEBPACK FOOTER //
// ./src/components/navigator/index.js